// eslint-disable-next-line
import { RouteView,BasicLayout } from '@/layouts';

import serve from "./modules/serve";
import user from "./modules/user";
import hospital from "./modules/hospital";

const baseMaps = [
  {
    path: "/login",
    name: "login",
    meta: { title: "登录", show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
  },
  {
    path: "/payLink",
    name: "payLink",
    meta: { show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/PayLink.vue"),
  },
  // {
  //   path: "/",
  //   name: "index",
  //   component: RouteView,
  //   meta: { title: "首页", show: false },
  //   redirect: "/serve"
  //   // children: modulesMap
  // }
];
const modulesMap = baseMaps.concat(serve, user, hospital);

// export const RouterMap = modulesMap;

export const RouterMap = [
  {
    path: "/",
    name: "index",
    component: BasicLayout,
    meta: { title: "首页" },
    redirect: "/serve",
    children: modulesMap,
  },
];
